import { CollectionPageState } from '../state';
import { createContext, useContext } from 'react';

const defaultValue = new CollectionPageState({});
const context = createContext<CollectionPageState>(defaultValue);

export const collectionPageContext = context;
export const CollectionPageContextProvider = context.Provider;
export const CollectionPageContextConsumer = context.Consumer;

export const useCollectionPageContext = () => useContext(context);
